/** 根据 appid 选择下载弹窗模板 */
export function getDownloadPopupTemplateType() {
  const appid = Number(JSON.parse(localStorage.getItem('localConfig')).appid)

  if (appid >= 52000 && appid < 53000) {
    return 'Index52000'
  }

  return 'Index50000'
}

/** 弹窗 logo */
export const downloadPopupLogoUrl = "/theme/logo/logo.png"
